module.exports = __webpack_public_path__ + "img/img11.3936f08d.svg";